import { IEffectModelValCollection, ISoftEdgeModelVal } from '@src/slide/domain/ui-model/element-modeles/property/effect/effect.interface';
import { emuToPt, ptToEmu } from '@src/slide/infrastructure/module/independent/unit';
import { ICTEffectList, ICTSoftEdgesEffect, DeltaOf } from '@tencent/slide-sdk-model';
import { DeepPartial, DeepReadonly } from 'ts-essentials';

/**
 * 效果 - 柔化边缘
 */
export class SoftEdgeConverter {
    /**
     * 柔化边缘的sdk -> ui 映射
     * @param sdkData
     * @param uiData
     */
    public static convertPartialDataFromSdkToUi(
        sdkData: DeepReadonly<DeepPartial<ICTEffectList>>,
        uiData: IEffectModelValCollection,
    ): void {
        if (sdkData.softEdge && Object.keys(sdkData.softEdge).length) {
            const size = SoftEdgeConverter.convertSizeFromSdkToUi(sdkData.softEdge);

            uiData.softEdge = { size };
            // 清掉值是undefined的属性
            Object.keys(uiData.softEdge || {}).forEach((p) => {
                if (uiData.softEdge && uiData.softEdge[p] === undefined) {
                    delete uiData.softEdge[p];
                }
            });
        } else {
            delete uiData.softEdge;
        }
    }

    /**
     * 柔化边缘的ui-> sdk 映射
     * @param uiData
     * @param sdkData
     */
    public static convertPartialDataFromUiToSdk(
        uiData: DeepPartial<IEffectModelValCollection>,
        sdkData: DeltaOf<ICTEffectList>,
    ): void {
        if (uiData.softEdge) {
            sdkData.softEdge = {
                rad: SoftEdgeConverter.convertSizeFromUiToSdk(uiData.softEdge),
            };
        } else if (uiData.softEdge === null) {
            sdkData.softEdge = null;
        }
    }

    // size
    private static convertSizeFromSdkToUi(sdkData?: DeepReadonly<DeepPartial<ICTSoftEdgesEffect>> | null): number {
        if (sdkData?.rad || sdkData?.rad === 0) {
            return emuToPt(sdkData.rad);
        }
        return 0;
    }

    // size
    private static convertSizeFromUiToSdk(uiData?:
    DeepPartial<ISoftEdgeModelVal> | null): number | undefined {
        if (uiData?.size || uiData?.size === 0) {
            return ptToEmu(uiData.size);
        }
    }
}
